import { AppModule } from "./app/app.module";
import { platformBrowser } from "@angular/platform-browser";
import { provideZoneChangeDetection } from "@angular/core";

// Angular 21+ enables zoneless change detection by default. This app relies on
// zone.js to trigger change detection after async work (HTTP, timers), so we
// opt back into zone-based change detection at the application provider level.
// (Must be passed here, not in AppModule.providers, to override the framework default.)
platformBrowser()
    .bootstrapModule(AppModule, {
        applicationProviders: [provideZoneChangeDetection()],
    })
    .catch((err) => console.error(err));
